"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgMenuHeavy(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M21 17a1 1 0 01.117 1.993L21 19H3a1 1 0 01-.117-1.993L3 17h18zm0-6a1 1 0 01.117 1.993L21 13H3a1 1 0 01-.117-1.993L3 11h18zm0-6a1 1 0 01.117 1.993L21 7H3a1 1 0 01-.117-1.993L3 5h18z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgMenuHeavy;
exports.default = _default;